import React from 'react';

import PaiTextField from 'features/ui/base-components/pai-text-field';
import { useTranslation } from 'react-i18next';
import { BasicActionDialog } from '../../ui/base-dialogs';

interface Props {
  open: boolean;
  tagName: string;
  loading: boolean;

  handleClose(): void;

  handleProceed(): void;

  handleTagNameChange(event: React.ChangeEvent<HTMLInputElement>): void;
}

const EditSurveyFolderDialog: React.FC<Props> = ({ tagName, handleTagNameChange, ...remProps }) => {
  const { t } = useTranslation();
  return (
    <BasicActionDialog
      dialogTitle={t('folderRename')}
      proceedButtonText={t('edit')}
      cancelButtonText={t('cancel')}
      maxWidth={'xs'}
      proceedButtonDisabled={tagName.trim() === ''}
      {...remProps}
    >
      <PaiTextField label={t('chooseName')} value={tagName} onChange={handleTagNameChange} />
    </BasicActionDialog>
  );
};

export default EditSurveyFolderDialog;
